import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ProfileQuery } from "../../../graphql/deliveryService/queries/profile";
import { ProfileFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useProfilesQueryProps {
  dataAction: (data: ProfileFragment) => void;
  errorAction?: () => void;
}

const useProfilesQuery = (props: useProfilesQueryProps) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const query = useQuery(ProfileQuery);

  const { data, error } = query;

  const profileFragment = data?.profile;

  useEffect(() => {
    if (!error) return;

    handleError(t("profileError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !profileFragment) return;

    dataAction(profileFragment);
  }, [data]);

  return query;
};

export default useProfilesQuery;
